import styled from '@emotion/styled';

import { Grid } from '@hrworks/sui-core/Grid';

import { mq } from '../../util/mediaQueries';

const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: theme.eclipseTier1.spacing['48px'],

  // Die Feld-Borders in sui-core sind kein `border`, sondern ein inset-boxShadow. iOS Safari
  // (z. B. iPhone 8) ignoriert boxShadow und borderRadius auf Inputs mit nativer Appearance,
  // dadurch fehlen dort die Umrandungen. Checkbox/Radio bleiben ausgenommen, die brauchen
  // ihr natives Rendering.
  'input:not([type="checkbox"]):not([type="radio"]), textarea': {
    WebkitAppearance: 'none',
    appearance: 'none',
  },
}));

const FormFieldContainer = styled(Grid)(({ theme }) => ({
  marginTop: theme.eclipseTier1.spacing['16px'],
  [mq.isSmallDevice]: {
    '& > *': {
      flexBasis: '100% !important',
      maxWidth: '100% !important',
    },
  },
}));

const ButtonWrapper = styled.div(({ theme }) => ({
  marginTop: theme.eclipseTier1.spacing['16px'],
  display: 'flex',
  justifyContent: 'flex-end',
}));

const PrivacyLink = styled.a({
  textDecoration: 'none',
  color: 'inherit',
  '&:hover': {
    opacity: 0.7,
  },
});

export const S = {
  Container,
  FormFieldContainer,
  ButtonWrapper,
  PrivacyLink,
} as const;
